import { FC } from "react";
import clockIcon from "../../../assets/images/dashboard-card-clock-icon.svg";
import locationIcon from "../../../assets/images/dashboard-card-location-icon.svg";
import contentImage from "../../../assets/images/dashboard-content-image.png";

const InActiveMemberLineupView: FC = () => {
  return (
    <div className="dashboard-screen-coming-up-events-container-item">
      <div
        className="image-container"
        style={{ backgroundImage: `url(${contentImage})` }}
      >
        <div
          className="dashboard-screen-spots-container"
          style={{ justifyContent: "space-between" }}
        >
          <div
            className="content"
            style={{ marginLeft: "6px", marginTop: "6px" }}
          >
            <span className="primary">10</span>
            <span className="secondary">Dec</span>
          </div>
          <div className="city-container">Mohali</div>
        </div>
      </div>
      <div className="title-container ">
        <span className="title-reservations">Founders in Flow</span>
      </div>
      <div className="divider-reservation"></div>
      <div className="footer-container">
        <div className="item-container">
          <img src={clockIcon} alt="clock-icon" /> 4:00 PM
        </div>
        <div className="item-container">
          <img src={locationIcon} alt="location-icon" /> Cafe Sabe
        </div>
      </div>
    </div>
  );
};

export default InActiveMemberLineupView;
